export default {
  setUserToken(state, payload) {
    state.user.access_token = payload.access_token;
    state.user.user_id = payload.user_id;
  },
};
